import React, { useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { FeedWrapper, TitleWrapper, DescWrapper } from '../Promos.style';
import Icon from '@mlb/react-patterns/v4/components/Icon/icon';
import { IconWrapper } from '../../Play/play/SummaryPlayEvents.style';
import { useTranslator } from '@gameday/utils/hooks/useTranslator';
import getPlayerOfTheGameState from '../../PlayerOfTheGame/store/selectors/getPlayerOfTheGameState';
import useTracking from '@gameday/utils/hooks/useTracking';
import { getDeviceInteraction } from '@gameday/utils/selectors/getDeviceInteraction';
import Link from '@mlb/react-patterns/v4/components/Link/link';
const EMPTY = Object.freeze({});

const Feed = ({
    descriptionKey,
    headerKey,
    icon,
    link,
    trackingProps = EMPTY,
    rules
}) => {
    const description = useTranslator(descriptionKey, '');
    const header = useTranslator(headerKey, '');
    const Tracking = useTracking();
    const { deviceInteraction } = useSelector(getDeviceInteraction);
    const { voteLink } = useSelector(getPlayerOfTheGameState);
    const { componentName = [] } = trackingProps;
    const isPOTG = rules === 'potg';

    if (!description && !header) {
        return null;
    }

    const handleVotePage = useCallback((e) => {
        const anchorEl = e?.currentTarget;

        const cfg = {
            componentName,
            text: e?.target?.innerText,
            activity: 'Feed Link Click'
        };

        Tracking.track.track_click(cfg);

        if (anchorEl && deviceInteraction) {
            const link = anchorEl.getAttribute('href');
            if (deviceInteraction.webview({ url: link })) {
                e.preventDefault();
                return false;
            }
        }
    }, [deviceInteraction, componentName, Tracking]);

    const handlers = useMemo(() => ({
        onClick: handleVotePage
    }), [handleVotePage]);

    const feedLink = isPOTG ? voteLink : link;

    return (
        <FeedWrapper>
            {icon && <IconWrapper><Icon name={icon} width='24' /></IconWrapper>}
            <TitleWrapper>{header}</TitleWrapper>
            {description && <DescWrapper>
                {feedLink
                    ? <Link
                        url={feedLink}
                        target='_blank'
                        ariaLabel={description}
                        dataAttr={{ 'data-url': voteLink }}
                        handlers={handlers}
                    >
                        {description}
                    </Link>
                    : description }
            </DescWrapper>}
        </FeedWrapper>
    );
};

Feed.propTypes = {
    headerKey: PropTypes.string,
    descriptionKey: PropTypes.string,
    icon: PropTypes.string,
    trackingProps: PropTypes.object,
    link: PropTypes.string,
    rules: PropTypes.string
};

export default Feed;
